type EnvironmentKind = 'production' | 'UAT' | 'staging' | 'local';

/**
  Statically calculates what kind of environment we're currently running in.
  The return value should not change when the function is called multiple times, as its output is based on values that will not change during a browser session.

  If we can't figure out what kind of env we're in, we default to 'production', as that's the safest assumption and avoids us turning on testing utils for production code.
**/
export function getEnvironmentKind(): EnvironmentKind {
  if (window.location.port === '8080') return 'local';
  if (window.location.hostname === 'utest1.work') return 'local';
  if (window.location.hostname === 'localhost') return 'local';

  const uatUrlPattern = /^https:\/\/.*\.?(utest[123])\.work$/u;
  if (uatUrlPattern.test(window.location.origin)) {
    if (window.location.pathname.startsWith('/.environments/'))
      return 'staging';

    return 'UAT';
  }

  return 'production'; // if we can't
}

export function getIsProductionEnvironment() {
  return getEnvironmentKind() === 'production';
}

export function getIsNonProductionEnvironment() {
  return getEnvironmentKind() !== 'production';
}

export function getIsDeployedNonProdEnvironment() {
  return getEnvironmentKind() === 'UAT' || getEnvironmentKind() === 'staging';
}

export function getIsLocalEnvironment() {
  return getEnvironmentKind() === 'local';
}
